export const QUIZ_CONFIG_CONVERSION_TYPES = {
  finance: 'finance',
  financeStandalone: 'finance-standalone',
  sellerConversion: 'seller-conversion',
  house: 'house'
}

export const QUIZ_STEP_TYPES = {
  houseType: 'house-type',
  mfhType: 'mfh-type',
  mfhUsage: 'mfh-usage',
  mfhLivingArea: 'mfh-living-area',
  mfhBudget: 'mfh-budget',
  livingAreaTotal: 'living-area-total',
  expansionStage: 'expansion-stage',
  property: 'property',
  constructionStart: 'construction-start',
  constructionMethod: 'construction-method',
  cataloguePreference: 'catalogue-preference',
  financingConsultationInterest: 'financing-consultation-interest',
  contactPreference: 'contact-preference',
  loanPurpose: 'loan-purpose',
  financeBuyingStage: 'finance-buying-stage',
  loanDetails: 'loan-details',
  housePurpose: 'house-purpose',
  maritalStatus: 'marital-status',
  numberOfKids: 'number-of-kids',
  occupation: 'occupation',
  houseBuyerStage: 'house-buyer-stage',
  customRadio: 'custom-radio',
  financialDetails: 'financial-details',
  loanAmountSlider: 'loan-amount-slider',
  equitySlider: 'equity-slider',
  propertyType: 'property-type',
  propertySubtype: 'property-subtype',
  floorNumber: 'floor-number',
  objectAddress: 'object-address',
  monthlyIncomeSlider: 'monthly-income-slider',
  customSlider: 'custom-slider',
  budget: 'budget',
  deliveryRegion: 'delivery-region',
  householdIncome: 'household-income',
  livingAndLandArea: 'living-and-land-area',
  checkoutNameEmail: 'checkout-name-email',
  checkoutValueMessage: 'checkout-value-message',
  checkoutContact: 'checkout-contact',
  checkoutAddress: 'checkout-address',
  exclusiveLeadCheckoutAddress: 'ex_checkout-address',
  checkoutAddressPhone: 'checkout-address-phone',
  checkoutEmailPhoneAddress: 'checkout-email-phone-address',
  checkoutGenderNameBirthdate: 'checkout-gender-name-birthdate',
  checkoutPersonalDetails: 'checkout-personal-details',
  checkoutPersonalDetailsBirthdate: 'checkout-personal-details-birthdate',
  checkoutFixedPersonalDetailsBirthdate: 'checkout-fixed-details-birthdate',
  exclusiveLeadCheckoutEmailPhone: 'ex_checkout-email-phone',
  exclusiveLeadCheckoutPhone: 'ex_checkout-phone',
  exclusiveLeadCheckoutGenderName: 'ex_checkout-gender-name',
  exclusiveLeadCheckoutGenderNameEmailPhone:
    'ex_checkout-gender-name-email-phone',
  exclusiveLeadCheckoutGenderNameEmail: 'ex_checkout-gender-name-email',
  sellerLeadCheckoutEmailPhone: 'seller-lead-checkout-question-email-phone',
  sellerLeadCheckoutNameEmailPhone:
    'seller-lead-checkout-question-name-email-phone',
  success: 'success',
  validation: 'validation',
  expectedValue: 'expected-value',
  financialMeans: 'financial-means',
  valuationInterest: 'valuation-interest'
}

export const LIST_OF_ALLOWED_PARAMS = [
  'house_type',
  'two_families_house_type',
  'mfh_type',
  'mfh_usage',
  'living_area_total',
  'expansion_stage',
  'property',
  'construction_start',
  'construction_method',
  'contact_preference',
  'catalogue_preference',
  'expected_value',
  'equity',
  'loan_amount',
  'loan_purpose',
  'house_purpose',
  'property_type',
  'building_costs',
  'property_costs',
  'agent_fee',
  'purchase_price',
  'modernization_costs',
  'finance_buying_stage',
  'household_income',
  'monthly_income',
  'birthdate',
  'marital_status',
  'number_of_kids',
  'occupation',
  'financing_consultation_interest',
  'bauort',
  'budget_range',
  'gender',
  'email',
  'first_name',
  'last_name',
  'phone',
  'phone_country_prefix',
  'street',
  'postal_code',
  'city',
  'country',
  'receive_newsletter',
  'selected_instances',
  'selected_instances_class',
  'valuation_interest',
  'property_type',
  'ua_delivery_region_verbose'
]

export const CONSTRUCTION_METHODS_MAPPING = [
  { name: 'prefab', value: '1' },
  { name: 'solid', value: '2' },
  { name: 'blockhouse', value: '3' },
  { name: 'na', value: 'na' }
]

export const CATALOG_REQUEST_ALLOWED_PARAMS = [
  'construction_start',
  'property',
  'contact_preference',
  'gender',
  'first_name',
  'last_name',
  'email',
  'phone',
  'phone_country_prefix',
  'receive_newsletter',
  'selected_instance_class',
  'selected_instances',
  'street',
  'postal_code',
  'city',
  'country',
  'birthdate',
  'number_of_kids',
  'marital_status',
  'occupation',
  'household_income',
  'monthly_income',
  'financing_consultation_interest',
  'expected_value',
  'equity',
  'loan_amount',
  'loan_purpose',
  'house_purpose',
  'property_condition',
  'property_construction_year',
  'property_parking_option',
  'property_type',
  'property_subtype',
  'property_floor_number',
  'property_street',
  'property_postal_code',
  'property_city',
  'property_country',
  'property_living_area',
  'property_number_of_rooms',
  'property_land_area',
  'property_last_modernization',
  'property_interior_quality',
  'seller_urgency',
  'building_costs',
  'property_costs',
  'agent_fee',
  'purchase_price',
  'modernization_costs',
  'delivery_region',
  'finance_buying_stage',
  'valuation_interest',
  'property_type',
  'house_buyer_stage'
]

export const STANDARD_FINANCE_STANDALONE_PARTNER_NID = 'ec2bc5be'

export const SEND_REQUEST_DELAY = 10

export const DEFAULT_EXPECTED_VALUE = 350000

export const DEFAULT_LOAN_EXPECTED_VALUE = 300000

export const DEFAULT_EQUITY_VALUE = 50000

export const DEFAULT_MONTHLY_INCOME_VALUE = 5000

export const STEP_TRANSITION_DURATION = 300

export const STEP_TRANSITION_IN_OUT_DURATION = 50

export const MID_STEP_LOADER_APPEARANCE_TIME = 2000

export const TRANSITION_ANIMATION_TIME_MS = 3000

export const POST_ANIMATION_TIME_TO_REDIRECT_MS = 500

export const TRANSITION_MULTI_POINT_NEXT_POINT_INTERVAL = 1500

export const TRANSITION_MULTI_POINT_MOVE_TO_CHECKOUT_DELAY = 1000
